(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-slide-link]');
    if (!target || event.target.closest('a, button')) return;

    const url = target.dataset.slideLink;
    if (event.metaKey || event.ctrlKey) {
      window.open(url, '_blank');
    } else {
      window.location.href = url;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
